import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import HTMLSnippet from '../snippets/HTMLSnippet';
import style from '../../css/components/headers/portalBarWrapper.css';
import { AppContext } from '../../Store';
import { OneLPSsdkParamsContext } from '../../onelps-sdk-params-context';

import { useScript } from '../../helpers/custom-hooks/useScript';
import { ENVIRONMENTS } from '../../constants/environments';

function PortalBar() {
	const onelpsParams = useContext(OneLPSsdkParamsContext);
	const [state, dispatch] = useContext(AppContext);

	const [portalBarHTML, setPortalBarHTML] = useState(null);
	const [portalBarCSS, setPortalBarCSS] = useState(null);

	const [portalBarLocalCSSHref, setPortalBarLocalCSSHref] = useState(null);

	useEffect(() => {
		if (onelpsParams.portalBar.marketSelection) {
			localStorage.setItem('PortalBar_FeatureFlag_Market_Selection', 'yes');
		} else {
			localStorage.setItem('PortalBar_FeatureFlag_Market_Selection', 'no');
		}
	}, [onelpsParams.portalBar.marketSelection]);

	useEffect(() => {
		if (onelpsParams.portalBar.crossSelling) {
			localStorage.setItem('PortalBar_FeatureFlag_Cross_Selling', 'yes');
		} else {
			localStorage.setItem('PortalBar_FeatureFlag_Cross_Selling', 'no');
		}
	}, [onelpsParams.portalBar.crossSelling]);

	useEffect(() => {
		if (onelpsParams.portalBar.fullWidth) {
			localStorage.setItem('PortalBar_FeatureFlag_UI_FullWidth','yes');
		} else {
			localStorage.setItem('PortalBar_FeatureFlag_UI_FullWidth','no');
		}
	}, [onelpsParams.portalBar.fullWidth]);

	useEffect(() => {
		if (ENVIRONMENT !== ENVIRONMENTS.DEVELOPMENT) {
			fetch(onelpsParams.portalBarHTML).then(function (response) {
				if (!response.ok) {
					setPortalBarHTML(null);
					return null;
				} else {
					return response.text();
				}
			}).then(function (html) {
				setPortalBarHTML(html);
			}).catch(function (err) {
				console.warn('!!! Something went wrong.', err);
			});

		} else {
			try {
				const portalBarLocalHTML = require('../../../portalBarHTML_local.html').default;
				setPortalBarHTML(portalBarLocalHTML);
			} catch (err) {
				console.warn('!!! Something went wrong.', err);
				setPortalBarHTML(null);
			}
		}
	}, []);

	useEffect(() => {
		if (ENVIRONMENT !== ENVIRONMENTS.DEVELOPMENT) {
			fetch(onelpsParams.portalBarCSS).then(function(response) {
				if (!response.ok) {
					console.log('Something was wrong with fetching the Portal Bar CSS. Portal Bar will not be rendered.');
					setPortalBarCSS(null);
					return null;
				} else {
					return response.text();
				}
			}).then(function(css) {
				setPortalBarCSS(css);
			});
		} else {
			setPortalBarLocalCSSHref('https://portal-bar.innogames.de/css/portal-bar.'+ onelpsParams.gameId + '.css');
		}
	}, []);

	const status = useScript(onelpsParams.portalBarJS);

	useEffect(() => {
		if (status === 'ready' && !state.portalBarInitialized && typeof Portal !== 'undefined' && portalBarHTML) {
			var pb = new Portal.Bar();
			pb.run();
			dispatch({ type: 'INITIALIZE_PORTAL_BAR' });
		}
	}, [status, portalBarHTML]);

	// Avoid rerendering HTMLSnippet when parent rerender,
	// If HTMLSnippet would rerender this would overwrite the portal-bar HTML and undoes the changes the script did.
	const html = useMemo(() => {
		if (!portalBarHTML) {
			return null;
		}

		return <HTMLSnippet
			snippet={portalBarHTML}
			callback={() => {
				dispatch({ type: 'MARK_PORTAL_BAR_HTML_LOADED' });
			}}
		/>;
	}, [dispatch, portalBarHTML]);

	return (
		<div
			id="pbar"
			data-testid="pbar"
		>
			{portalBarCSS && (
				<HelmetProvider>
					<Helmet>
						<style type='text/css'>{portalBarCSS}</style>
					</Helmet>
				</HelmetProvider>
			)}
			<div
				className={`${(state.portalBarInitialized && (portalBarCSS || portalBarLocalCSSHref)) ? style.show : style.hide} ${onelpsParams.abTestFeatureFlags?.['stellarAgeCustomStyle'] === true ? style.stellarAge : '' }`}
				data-testid="pbarHtmlWrapper"
			>
				{portalBarHTML && (
					html
				)}
			</div>
			{ENVIRONMENT === ENVIRONMENTS.DEVELOPMENT && (
				<HelmetProvider>
					<Helmet>
						<link
							rel="stylesheet"
							href={portalBarLocalCSSHref}
						/>
					</Helmet>
				</HelmetProvider>
			)}
		</div>
	);
}

export default PortalBar;
